// src/utils/tourStorage.js
export const getTourState = (routeKey) => {
  try {
    const raw = localStorage.getItem(`uc_tour_${routeKey}`);
    return raw ? JSON.parse(raw) : { run: true, stepIndex: 0, completed: false };
  } catch {
    return { run: true, stepIndex: 0, completed: false };
  }
};

export const saveTourState = (routeKey, state) => {
  localStorage.setItem(`uc_tour_${routeKey}`, JSON.stringify(state));
};

export const resetTourState = (routeKey) => {
  localStorage.removeItem(`uc_tour_${routeKey}`);
};
